import React from 'react';
import UserBookings from './user/UserBookings'; // Ensure this path is correct based on where UserBookings was created
import { useLocalization } from '../hooks/useLocalization';

export const MyBookingsPage: React.FC = () => {
    const { t } = useLocalization();

    return (
        <div className="bg-gray-50 min-h-screen py-10">
            <div className="container mx-auto px-4 max-w-4xl">
                <div className="mb-6">
                    <h1 className="text-3xl font-bold text-gray-900">{t('my_bookings') || 'My Bookings'}</h1>
                    <p className="text-gray-500">{t('manage_reservations') || 'Manage your reservations and documents'}</p>
                </div>

                <UserBookings />
            </div>
        </div>
    );
};
